import { MutationFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { isMockServices } from 'src/utils';
import mock from '../utils/mock';

export interface UpdateMappingByIdParams {
  id: string;
  target_folder: string;
  filename: string;
  document_type: string;
}

const updateMappingById: MutationFunction<
  boolean,
  UpdateMappingByIdParams
> = async (args) => {
  if (isMockServices()) return await mock(true);
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{ success: boolean }>(
    `/mappings/${args.id}`,
    {
      method: 'PUT',
      body: {
        target_folder: args.target_folder,
        filename: args.filename,
        document_type: args.document_type,
      },
    },
  );
  if (response.data) return response.data.success;
  throw new Error('Failed to update mapping');
};

export default updateMappingById;
